<template lang="pug">
#cadastrar-monitoramento
    BaseHeader(
        titulo='Novo Monitoramento Socioambiental',
        :voltarPara='voltarPara',
        icon='mdi mdi-play',
        btnTexto='Iniciar monitoramento',
        :exibeBotao='true',
        :desabilitaBotao='desabilitaBotao',
        @btnHeaderClicado='confirma'
    )

    FiltrarTerritorioMonitoramento(
        :isMonitoramentoSocioambiental='true',
        @atualizar-filtro='atualizarFiltro'
    )
    TabelaSelecionarTerritorioMonitoramento(
        v-loading='buscandoTerritorios',
        ref="tableComponent",
        @rows-selecionados-changed='handleRowsSelecionadosChanged',
        :dadosTabelaMonitoramento='dadosTabelaMonitoramento',
        :paginacao='paginacao',
        tipo='SOCIOAMBIENTAL',
        @atualizar-pagina='atualizarPagina',
        @atualizar-tabela='buscarTerritorios'
    )

    el-dialog(
        :title="$t('mensagens.monitoramentoSocioambiental.novoMonitoramento.modal.title')",
        :visible.sync='mostrarAlertaProtocoloPadrao',
        :before-close='fecharModal',
        width='700px',
        append-to-body,
        destroy-on-close
    )
        p(v-if='selectedProtocolo') {{ $t('mensagens.monitoramentoSocioambiental.novoMonitoramento.modal.empresaPossuiMultiplosProtocolos') }}
            b {{ selectedProtocolo.descricao }}
            span , {{ $t('mensagens.monitoramentoSocioambiental.novoMonitoramento.modal.queFoiDefinidoComoPadrao') }}
        div.d-flex
            BaseButton.align-self-center.w-100.my-3(
                type='info',
                size='large',
                key='btnNaoIniciarMonitoramento',
                @click='mostrarAlertaProtocoloPadrao = false'
            ) {{ $t('mensagens.comuns.cancelar') }}
            BaseButton.align-self-center.w-100.my-3(
                type='primary',
                size='large',
                key='btnIniciarMonitoramento',
                @click='handleIniciarMonitoramento'
            ) {{ $t('mensagens.monitoramentoSocioambiental.novoMonitoramento.baseHeader.botao') }}

</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import FiltrarTerritorioMonitoramento from '@/components/monitoramento/FiltrarTerritorioMonitoramento';
import TabelaSelecionarTerritorioMonitoramento from '@/components/monitoramento/TabelaSelecionarTerritorioMonitoramento';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';
import { ProtocolosService } from '@/services/ProtocolosService';
import constantes from '@/utils/constantes';

export default {
    name: 'CadastrarMonitoramentoSocioAmbiental',
    components: {
        BaseHeader,
        FiltrarTerritorioMonitoramento,
        TabelaSelecionarTerritorioMonitoramento,
        BaseButton
    },
    data() {
        return {
            nomeColumn: null,
            desabilitaBotao: true,
            voltarPara: {
                route: 'MonitoramentoSocioambiental'
            },
            paginacao: {
                tamanho: constantes.TAMANHO_PAGINA,
                pagina: 0,
                ordenacao: 'nome'
            },
            filtros: {
                idNivel1: null,
                idNivel2: null,
                idBiomas: [],
                idTerritorios: [],
                idRepresentantes: []
            },
            dadosTabelaMonitoramento: {
                itens: [],
                paginaAtual: 0,
                totalItens: 0
            },
            buscandoTerritorios: true,
            voltarHome: false,
            mostrarAlertaProtocoloPadrao: false,
            protocolos: [],
            selectedProtocolo: {}
        };
    },
    async mounted() {
        this.validarRotaComParametro();

        await this.buscarProtocolosPorUsuario();
    },
    methods: {
        mostrarModal() {
            if (this.protocolos.length > 1) {
                this.mostrarAlertaProtocoloPadrao = true;
            } else {
                this.handleIniciarMonitoramento();
            }
        },

        fecharModal() {
            this.mostrarAlertaProtocoloPadrao = false;
        },

        handleIniciarMonitoramento() {
            this.mostrarAlertaProtocoloPadrao = false;
            this.$refs.tableComponent.iniciarMonitoramento();
        },

        handleRowsSelecionadosChanged(rowsSelecionadas) {
            this.desabilitaBotao = rowsSelecionadas.length === 0;
        },

        async buscarTerritorios() {
            this.buscandoTerritorios = true;
            const { data } =
                await MonitoramentoSocioambientalService.buscarTerritoriosNaoMonitorados(
                    this.filtros,
                    this.paginacao
                );
            this.dadosTabelaMonitoramento = data;
            this.buscandoTerritorios = false;
        },

        atualizarFiltro(dados) {
            this.filtros = dados;
            this.paginacao.pagina = 0;
            this.buscarTerritorios();
        },

        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina - 1;
            this.buscarTerritorios();
        },

        validarRotaComParametro() {
            if (this.$route.params.valor && this.$route.params.id) {
                this.voltarPara.route = 'Home';
            }
        },

        async buscarProtocolosPorUsuario() {
            this.protocolos = await ProtocolosService.buscarProtocolosPorUsuario();
            this.selectedProtocolo = this.protocolos.find(p => p.protocoloPadrao === true);
        },

        confirma() {
            let territoriosSemCPF = this.$refs.tableComponent.verificaTerritorioPessoaSemCPF();
            if (territoriosSemCPF !== '') {
                this.$messageBox.confirm(`${this.$t('mensagens.monitoramentoSocioambiental.mensagemPessoaEstrangeira1')}<br/>${this.$t('mensagens.monitoramentoSocioambiental.mensagemPessoaEstrangeira2')}<br/>${this.$t('mensagens.monitoramentoSocioambiental.mensagemPessoaEstrangeira3')}<br/>${territoriosSemCPF}`, this.$t('mensagens.comuns.atencao'), {
                    confirmButtonText: this.$t('mensagens.comuns.confirmar'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning',
                    dangerouslyUseHTMLString: true,
                    customClass: 'tamanho-mensagem',
                    cancelButtonClass: 'cancelar-left',
                    closeOnClickModal: false,
                    confirmButtonClass: 'confirma-focus-out'
                }).then(() => {
                    this.mostrarModal();
                }).catch(() => {
                });
            } else {
                this.mostrarModal();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
#cadastrar-monitoramento {
    .box-instrucao {
        float: left;
        height: 39px;
        margin-right: 14px;
        color: #3b3b3b;
        max-width: 269px;
        font-size: 13px;

        span {
            padding-left: 3px;
            color: #1989fa;
            text-decoration-line: underline;
        }
    }
}
</style>
<style lang="scss">
.tamanho-mensagem {
    width: 800px !important;
}

.cancelar-left {
    float: left;
}

.confirma-focus-out:focus {
    border-color: var(--primary) !important;
    background-color: var(--primary) !important;
    color: var(--white) !important;
}

.el-message-box__btns {
    button {
        width: 100px !important;
    }

    .el-button--primary {
        background-color: var(--primary);
        border-color: var(--primary);
        color: var(--white);
    }

    .el-button--primary:hover,
    .el-button--primary:focus {
        background-color: var(--secondary);
        border-color: var(--secondary);
        color: var(--color-button-hover);
        outline: 0px auto var(--secondary);
    }
}
</style>
